import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import help_icon from "../../assets/help_icon.svg";

export default function HelpModal({
  showHelpModal,
  setShowHelpModal,
  toggleHelp,
}) {
  const close = () => {
    setShowHelpModal(false);
  };

  return (
    <>
      <Modal
        className="help modal-dialog-centered"
        isOpen={showHelpModal}
        toggle={toggleHelp}
      >
        <ModalHeader>
          <img src={help_icon} className="help_icon" alt='' /> <span>Help</span>
        </ModalHeader>
        <ModalBody>
          <ul>
            <li>
              Please add all the places that you wish to travel to in this
              route.
            </li>
          </ul>
          <ul>
            <li>
              Optimize the route, so that the shortest and best possible route
              between the places is available to you, making your journey smooth
              and reducing the unnecessary wasted travel time you might have
              faced in case you took a wrong turn in your trip.
            </li>
          </ul>
          <ul>
            <li>
              Click on the Refresh button, to get the estimated travel time and
              distance to reach from one place to another place. This will
              benefit you by giving you an idea of how much more time you can
              actually spend in the place and how much will be required to be on
              your way to your desired destination.{" "}
            </li>
          </ul>
          <ul>
            <li>
              Hurray.. !! Have a Save and Enjoyable Trip you planned for
              yourself both beautifully and efficiently.
            </li>
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button onClick={close}>Close</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
